import React from 'react';

const RegionIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <g clipPath='url(#clip0_545_84229)'>
            <path
                d='M1.3335 7.99992H3.3335M3.3335 7.99992C3.3335 10.5772 5.42283 12.6666 8.00016 12.6666M3.3335 7.99992C3.3335 5.42259 5.42283 3.33325 8.00016 3.33325M12.6668 7.99992H14.6668M12.6668 7.99992C12.6668 10.5772 10.5775 12.6666 8.00016 12.6666M12.6668 7.99992C12.6668 5.42259 10.5775 3.33325 8.00016 3.33325M8.00016 1.33325V3.33325M8.00016 12.6666V14.6666M10.0002 7.99992C10.0002 9.10449 9.10473 9.99992 8.00016 9.99992C6.89559 9.99992 6.00016 9.10449 6.00016 7.99992C6.00016 6.89535 6.89559 5.99992 8.00016 5.99992C9.10473 5.99992 10.0002 6.89535 10.0002 7.99992Z'
                stroke='#00225F'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_545_84229'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { RegionIcon };
